//src/app/features/questionnaires/create/PrepareQuestionnaire/fields.ts
import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import { taxYearsOptions } from 'utils/yearSelectOptions';
import * as Yup from 'yup';
import { updateFieldArrayKey } from '../PrepareQuestionnaire/slice';
import { PrepareQuestionnaireState, updateKey } from './slice';

export const commonFields: IBaseField<keyof PrepareQuestionnaireState>[] = [
  {
    type: 'select',
    name: 'year',
    label: 'Which year would you like us to prepare? *',
    options: taxYearsOptions,
    effect: (payload) => store.dispatch(updateKey(payload)),
    dependencies: [
      {
        type: 'radio',
        name: 'citizenship',
        label:
          'In the selected year, were you a US citizen or did you hold a Green Card (GC)?',
        options: [
          { label: 'US Citizen', value: 'US Citizen' },
          { label: 'GC Holder', value: 'GC Holder' },
          {
            label: 'Not a US Citizen or GC Holder',
            value: 'Not a US Citizen or GC Holder',
          },
        ],
        predicate: (value) => !!value,
        effect: (payload) => store.dispatch(updateKey(payload)),
        dependencies: [
          {
            type: 'country',
            name: 'whatCountryAreYouACitizenOf',
            label: 'What country are you a citizen of?',
            predicate: (value) => value === 'Not a US Citizen or GC Holder',
            effect: (payload) => store.dispatch(updateKey(payload)),
          },
          {
            type: 'radio',
            name: 'daysOutsideUs',
            label:
              'Did you live outside of the U.S. during this calendar year?',
            options: [
              { label: 'Yes', value: 'yes' },
              { label: 'No', value: 'no' },
            ],
            predicate: (value) =>
              value === 'US Citizen' || value === 'GC Holder',
            effect: (payload) => store.dispatch(updateKey(payload)),

            dependencies: [
              {
                type: 'dateRanges',
                effect: (payload) =>
                  store.dispatch(updateFieldArrayKey(payload)),
                label: 'Please list the dates where you were in the US',
                name: 'daysInsideTheUsRange',
                predicate: (value) => value === 'yes',
              },
            ],
          },
          {
            name: 'daysOutsideUsyear1',
            type: 'text',
            dependenciesTitle:
              'OK, how many days did you spend in the U.S in the last three years?',
            label: (values) => {
              return `Days in the US in calendar year ${Number(values?.year)}`;
            },
            placeholder: 'Enter Days',
            predicate: (value) => value === 'Not a US Citizen or GC Holder',
            effect: (payload) => store.dispatch(updateKey(payload)),
          },
          {
            type: 'text',
            name: 'daysOutsideUsyear2',
            label: (values) => {
              return `Days in the US in calendar year ${
                Number(values?.year) - 1
              }`;
            },
            placeholder: 'Enter Days',
            predicate: (value) => value === 'Not a US Citizen or GC Holder',
            effect: (payload) => store.dispatch(updateKey(payload)),
          },
          {
            type: 'text',
            name: 'daysOutsideUsyear3',
            label: (values) => {
              return `Days in the US in calendar year ${
                Number(values?.year) - 2
              }`;
            },
            placeholder: 'Enter Days',
            predicate: (value) => value === 'Not a US Citizen or GC Holder',
            effect: (payload) => store.dispatch(updateKey(payload)),
          },
        ],
      },
    ],
  },
];

export const commonValidationObject = {
  year: Yup.string().nullable().required('required'),
  citizenship: Yup.string().when('year', {
    is: (value: string) => !!value,
    then: Yup.string().nullable().required('required'),
    otherwise: Yup.string().nullable(),
  }),
  daysInsideTheUsRange: Yup.array()
    .nullable()
    .when('daysOutsideUs', {
      is: 'yes',
      then: Yup.array()
        .nullable()
        .min(1, 'Required')
        .of(
          Yup.object().shape({
            from: Yup.string().nullable().required('required'),
            to: Yup.string().nullable().required('required'),
          }),
        ),
    }),
  daysOutsideUs: Yup.string().when('citizenship', (citizenship) => {
    if (citizenship === 'US Citizen' || citizenship === 'GC Holder') {
      return Yup.string().required('required').nullable();
    } else {
      return Yup.string().nullable();
    }
  }),
  daysOutsideUsyear1: Yup.string().when('citizenship', {
    is: 'Not a US Citizen or GC Holder',
    then: Yup.string().required('required').nullable(),
    otherwise: Yup.string().nullable(),
  }),
  daysOutsideUsyear2: Yup.string().when('citizenship', {
    is: 'Not a US Citizen or GC Holder',
    then: Yup.string().required('required').nullable(),
    otherwise: Yup.string().nullable(),
  }),
  daysOutsideUsyear3: Yup.string().when('citizenship', {
    is: 'Not a US Citizen or GC Holder',
    then: Yup.string().required('required').nullable(),
    otherwise: Yup.string().nullable(),
  }),
  whatCountryAreYouACitizenOf: Yup.string().when('citizenship', {
    is: 'Not a US Citizen or GC Holder',
    then: Yup.string().required('required').nullable(),
    otherwise: Yup.string().nullable(),
  }),
};
export const commonFieldsValidationSchema = Yup.object().shape(
  commonValidationObject,
);
